import React from "react";

import { FeaturedResourceBlock as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { HLevel } from "../Headings";
import { Card } from "./Card";
import { LAYOUT, STYLE } from "./constants";

import styles from "./FeaturedResource.module.scss";

export const FeaturedResource = ({ value }: { value: Value }) => (
    <HLevel>
        <section
            className={concatClassNames([
                value.layout === LAYOUT.TWO_UP ? styles.twoUp : styles.single,
                value.style === STYLE.OPEN ? styles.open : undefined,
            ])}
        >
            {value.cards?.map((card, i) => (
                <Card
                    key={i}
                    card={card}
                    style={value.style}
                    theme={value.module_theme}
                />
            ))}
        </section>
    </HLevel>
);
